export const isMembershipCoupon = (coupon: { name?: string } | string | null | undefined) => {
  const couponName = typeof coupon === "string" ? coupon : coupon?.name;

  return (couponName || "").toLowerCase().includes("membership");
};

export const isMembershipCouponBlockedForUser = (user: any) => {
  return !!(
    user?.preventBenefits
    || user?.membership === ""
    || user?.expand?.membership?.cantUseMembershipCoupons
  );
};
